import React, { ReactNode } from 'react';
import {
  cmsFeatureFlagContext,
  useCmsFeatureFlagConfig,
} from './useCmsFeatureFlagConfig';

type Props = {
  children: ReactNode;
};

export function CmsFeatureFlagProvider(props: Props) {
  const { children } = props;
  const featureFlagConfig = useCmsFeatureFlagConfig();
  const { Provider } = cmsFeatureFlagContext;
  return <Provider value={featureFlagConfig}>{children}</Provider>;
}
